const searchInput =
  document.querySelector('input[type="search"]#SearchInput-') ||
  document.querySelector('input[type="search"][id^="SearchInput-"]') ||
  document.querySelector('input[type="search"].search__input');

if (searchInput) {
  const placeholders =
    (Array.isArray(window.SEARCH_PLACEHOLDERS) && window.SEARCH_PLACEHOLDERS.length)
      ? window.SEARCH_PLACEHOLDERS
      : ["Search"];

  const TYPE_MS = Number(window.SEARCH_TYPING_SPEED)   || 120;
  const DEL_MS  = Number(window.SEARCH_DELETING_SPEED) || 60;
  const PAUSE   = Number(window.SEARCH_PAUSE_MS)       || 1200;

  let i = 0, j = 0, forward = true, stopped = false, timer = null;

  function tick() {
    if (stopped) return;
    const t = placeholders[i] || "";

    if (forward) {
      j++;
      searchInput.setAttribute("placeholder", t.substring(0, j));
      if (j === t.length) { forward = false; timer = setTimeout(tick, PAUSE); return; }
      timer = setTimeout(tick, TYPE_MS);
    } else {
      j--;
      searchInput.setAttribute("placeholder", t.substring(0, j));
      if (j === 0) { forward = true; i = (i + 1) % placeholders.length; }
      timer = setTimeout(tick, DEL_MS);
    }
  }

  function stop()  { stopped = true; if (timer) { clearTimeout(timer); timer = null; } }
  function start() { if (!stopped) return; stopped = false; tick(); }

  // Pause/resume rules:
  // - Any non-empty input => pause
  // - Empty input => resume immediately
  searchInput.addEventListener("input", () => {
    if (searchInput.value.trim() === "") {
      start();
    } else {
      stop();
    }
  });

  // Optional: don’t force-stop on focus; input handler governs behavior
  searchInput.addEventListener("blur", () => {
    if (searchInput.value.trim() === "") start();
  });

  if (searchInput.value.trim() === "") tick();
}
